import { useField, useFormikContext } from "formik";

const FormikFile = ({lname, serialNo, ...props}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  return (
    <>
      <div className="file">
      <label>Upload a copy of your receipt (.jgp, .png, .pdf, .heic)</label>
        <input
          name={props.name}
          type="file"
          accept='.jpg,.png,.pdf,.heic'
          onChange={(event) => {
            setFieldValue(field.name, event.target.files[0]);
            const date = new Date();
            const file_name = lname+"_"+serialNo+"_"+date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours() ).slice(-2) + ("0" + date.getMinutes()).slice(-2) + ("0" + date.getSeconds()).slice(-2);
            setFieldValue("fileName", file_name )
          }}
        />
      </div>

      {meta.touched && meta.error && <div className="error">{meta.error}</div>}
    </>
  );
};
export default FormikFile;